import { render, staticRenderFns } from "./EditCountries.vue?vue&type=template&id=3712372c&scoped=true"
import script from "./EditCountries.vue?vue&type=script&lang=ts"
export * from "./EditCountries.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3712372c",
  null
  
)

export default component.exports